/**
 * Portuguese translations
 */
import { common } from './pt/common';
import { dashboard } from './pt/dashboard';
import { vision2040 } from './pt/vision2040';
import { mentalHealth } from './pt/mentalHealth';
import { members } from './pt/members';
import { programs } from './pt/programs';
import { technology } from './pt/technology';
import { regional } from './pt/regional';
import { impact } from './pt/impact';
import { workforce } from './pt/workforce';
import { entrepreneurship } from './pt/entrepreneurship';
import { contributing } from './pt/contributing';
import { faq } from './pt/faq';
import { methodology } from './pt/methodology';
import { developmentCouncils } from './pt/developmentCouncils';
import { privacy } from './pt/privacy';
import { terms } from './pt/terms';
import { countryProfile } from './pt/countryProfile';

// NOTE: both Programs & Events and Technology modules used the same root key "programs".
// We deep-merge here to prevent one module from overwriting the other.
const { programs: programsLabels, ...programsRest } = programs;
const { programs: technologyProgramLabels, ...technologyRest } = technology;

export const pt = {
  ...common,
  ...dashboard,
  ...mentalHealth,
  ...regional,
  ...members,
  ...programsRest,
  ...impact,
  ...technologyRest,
  ...vision2040,
  ...workforce,
  ...entrepreneurship,
  ...contributing,
  ...methodology,
  ...developmentCouncils,
  ...countryProfile,
  privacy,
  terms,
  faq,
  programs: {
    ...programsLabels,
    ...technologyProgramLabels,
  },
} as const;

export type PtTranslations = typeof pt;

